// src/Dashboard/pages/teacher/Attendance/utils/attendanceUtils.js

export const STOPPED_STATUSES = [
  "Licencié - Arrêt",
  "Non Licencié - Arrêt",
  "Ancien Licencié et Arrêt",
];

export const STATUS_OPTIONS = [
  "",
  "Licencié",
  "Licencié Hors Club",
  "Inscrit",
  "Cours d'essai",
  "Licencié - Arrêt",
  "Non Licencié - Arrêt",
  "Ancien Licencié",
  "Ancien Licencié et Arrêt",
];

export function getLocalDateInput(date = new Date()) {
  const value = new Date(date);
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getSeasonNeighbors(season) {
  const match = /^(\d{4})\s*-\s*(\d{4})$/.exec(String(season || ""));

  if (!match) {
    return {
      prev: "",
      next: "",
    };
  }

  const start = Number(match[1]);
  const end = Number(match[2]);

  return {
    prev: `${start - 1}-${end - 1}`,
    next: `${start + 1}-${end + 1}`,
  };
}

export function normalizeAttendanceFilters(rawFilters = {}) {
  return {
    search: String(rawFilters.search || ""),
    selectedDojo: String(rawFilters.selectedDojo || ""),
    selectedSeason: String(rawFilters.selectedSeason || ""),
    filterGroup: String(rawFilters.filterGroup || ""),
    statutInscription: String(rawFilters.statutInscription || ""),
    selectedDate: String(rawFilters.selectedDate || getLocalDateInput()),

    hideStopped: Boolean(rawFilters.hideStopped ?? true),
    sortAssiduity: Boolean(rawFilters.sortAssiduity ?? false),
    onlyBirthday: Boolean(rawFilters.onlyBirthday ?? false),
    onlyBlessed: Boolean(rawFilters.onlyBlessed ?? false),
    onlyPresent: Boolean(rawFilters.onlyPresent ?? false),
    onlyAbsent: Boolean(rawFilters.onlyAbsent ?? false),
  };
}

export function buildDailyAttendanceMap(dateISO, adherentIds = [], allAttendances = []) {
  const day = String(dateISO || "").slice(0, 10);
  const ids = new Set(adherentIds.map(Number));

  const map = {};

  adherentIds.forEach((id) => {
    map[id] = 0;
  });

  (allAttendances || []).forEach((attendance) => {
    const attendanceDay = String(attendance?.date_presence || "").slice(0, 10);
    const adherentId = Number(attendance?.adherent_id);

    if (attendanceDay === day && ids.has(adherentId)) {
      map[adherentId] = attendance?.presence ? 1 : 2;
    }
  });

  return map;
}

export function getDefaultPhoto(genre) {
  return genre === "Masculin"
    ? "/img/judoka_avatar.png"
    : "/img/judokate_avatar.png";
}

export function toAbsolute(url) {
  if (!url) return "";

  const value = String(url).trim();

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (!value.startsWith("/uploads")) {
    return value;
  }

  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";
  return `${base}${value}`;
}

export function getAdherentPhoto(adherent) {
  if (adherent?.autorisation_photo === false) {
    return "/img/interdiction.jpg";
  }

  return (
    toAbsolute(
      adherent?.photo_url ||
        adherent?.photoURL ||
        adherent?.photo ||
        adherent?.avatar
    ) || getDefaultPhoto(adherent?.genre)
  );
}

export function getAdherentName(adherent) {
  const nom = String(adherent?.nom || "").trim().toUpperCase();
  const prenom = String(adherent?.prenom || "").trim();

  return `${nom} ${prenom}`.trim() || "Adhérent";
}

export function getGroupsLabel(adherent) {
  return (Array.isArray(adherent?.Groups) ? adherent.Groups : [])
    .map((group) => group?.nom)
    .filter(Boolean)
    .join(", ");
}

export function hasStoppedStatus(adherent) {
  return STOPPED_STATUSES.includes(adherent?.statut_inscription);
}

export function sortAdherentsByName(list = []) {
  return list.slice().sort((a, b) => {
    const byNom = String(a?.nom || "").localeCompare(
      String(b?.nom || ""),
      "fr",
      { sensitivity: "base" }
    );

    if (byNom !== 0) return byNom;

    return String(a?.prenom || "").localeCompare(
      String(b?.prenom || ""),
      "fr",
      { sensitivity: "base" }
    );
  });
}

export function formatDateLongFR(dateValue) {
  if (!dateValue) return "—";

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function getAttendanceStatusMeta(status) {
  if (status === 1) {
    return {
      label: "Présent",
      shortLabel: "P",
      overlay: "bg-emerald-500/55",
      badge:
        "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-200 dark:ring-emerald-800/60",
    };
  }

  if (status === 2) {
    return {
      label: "Absent",
      shortLabel: "A",
      overlay: "bg-rose-500/55",
      badge:
        "bg-rose-50 text-rose-700 ring-1 ring-rose-200 dark:bg-rose-900/20 dark:text-rose-200 dark:ring-rose-800/60",
    };
  }

  return {
    label: "Non saisi",
    shortLabel: "—",
    overlay: "",
    badge:
      "bg-slate-100 text-slate-600 ring-1 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
  };
}